export { ThemeProvider, useTheme } from './ThemeContext';
export type { ThemeName } from './ThemeContext';

import JapanLayout from './japan/layout';
import JapanHeader from './japan/header';
import JapanFooter from './japan/footer';
import JapanHome from './japan/home';
import DefaultLayout from './default/layout';
import DefaultHeader from './default/header';
import DefaultFooter from './default/footer';
import DefaultHome from './default/home';
import './default/styles.css';

export const themes = {
  japan: {
    name: 'japan' as const,
    displayName: 'Japan Theme',
    Layout: JapanLayout,
    Header: JapanHeader,
    Footer: JapanFooter,
    Home: JapanHome,
  },
  default: {
    name: 'default' as const,
    displayName: 'Default Theme',
    Layout: DefaultLayout,
    Header: DefaultHeader,
    Footer: DefaultFooter,
    Home: DefaultHome,
  },
};

export type ThemeConfig = typeof themes.japan;
